import { z } from 'zod';
import { cropSettingsMapSchema } from './cropSettingsSchema';

const RiverCustomFieldsSchema = z
  .object({
    description: z.string().optional(),
    image: z
      .object({
        alt: z.string().optional(),
        originalUrl: z.string(),
        cropSettings: cropSettingsMapSchema.optional(),
      })
      .nullable()
      .optional(),
    birthDate: z.string().optional(),
  })
  .optional()
  .nullable();

type RiverCustomFields = z.infer<typeof RiverCustomFieldsSchema>;

export type { RiverCustomFields };
export { RiverCustomFieldsSchema };
